import React from "react";
import { GameClient } from "../gameClient";
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";

declare var gameClient: GameClient;

interface OpponentNameHeaderProps {
	opponentName: string;
}

const style: React.CSSProperties = {
	position: "absolute",
	color: Colors.UITextAndBorders,
	background: `url(${backgroundTexture})`,
	backgroundColor: Colors.UIBackground,
	textAlign: "center",
	verticalAlign: "middle",
	borderRadius: "10pt",
	border: `solid 3px ${Colors.UITextAndBorders}`,
	top: "15%",
	left: "50%",
	transform: "translateX(-50%)",
	paddingTop: "0.2em",
	paddingBottom: "0.2em",
	paddingLeft: "1em",
	paddingRight: "1em",
	fontFamily: 'NotoSansDisplay',
	fontSize: '1.5rem',
};

export const OpponentNameHeader = (props: OpponentNameHeaderProps) => {
	return (
		<div style={style}>{props.opponentName}'s Turn</div>
	)
}